export const Icon = ({icon, style, size = 15, color = "currentColor", rotation = 0}) => {
    
    return(
        <div style={{color:color,  height:size, width:size, ...style,}}>
            <svg style={{height:`${size}px`, width:`${size}px`}} >
                <use xlinkHref={icon?.toString() + "#svg"} href={icon?.toString() + "#svg"} width={`${size}px`} height={`${size}px`} origin="center" style={{transformBox:"fill-box", transformOrigin:"center", transform:`rotate(${rotation}deg)`}}/> 
            </svg>
        </div>
        
    );
}